import React, { useState, useCallback, useEffect, forwardRef } from "react";
import {
  FormLayout,
  TextField,
  Text,
  Stack,
  RadioButton,
  Checkbox,
} from "@shopify/polaris";

const WidthStyle = (props) => {
  const handleChangeWidth = (_checked, newValue) => {
    props.handleChangeWidth(_checked, newValue);
  };
  const handleChangeMinimumWidth = (newValue) => {
    props.handleChangeMinimumWidth(newValue);
  };
  const handleChangeMaximumWidth = (newValue) => {
    props.handleChangeMaximumWidth(newValue);
  };
  const handleChangeCustomWidth = (newValue) => {
    props.handleChangeCustomWidth(newValue);
  };
  const handleChangeWidthMobile = (_checked, newValue) => {
    props.handleChangeWidthMobile(_checked, newValue);
  };
  const handleChangeMinimumWidthMobile = (newValue) => {
    props.handleChangeMinimumWidthMobile(newValue);
  };
  const handleChangeMaximumWidthMobile = (newValue) => {
    props.handleChangeMaximumWidthMobile(newValue);
  };
  const handleChangeCustomWidthMobile = (newValue) => {
    props.handleChangeCustomWidthMobile(newValue);
  };
  const handleChangeMobileWidth = (newValue) => {
    props.handleChangeMobileWidth(newValue);
  };
  const [checkedMobileWidth, setCheckedMobileWidth] = useState(
    props?.item?.width?.customWidth ? true : false
  );
  const handleChangeCheckedMobileWidth = useCallback(
    (newChecked) => setCheckedMobileWidth(newChecked),
    []
  );
  return (
    <FormLayout>
      <Text variant="headingSm" as="h6">
        SECTION WIDTH
      </Text>
      <Text variant="headingXs" as="h6">
        DESKTOP
      </Text>
      <Stack horizontal>
        <RadioButton
          label="Minimum/Maximum Width"
          checked={props.item.width.type.desktop === "9"}
          id="9"
          onChange={handleChangeWidth}
        />
        <RadioButton
          label="Custom Width"
          id="10"
          checked={props.item.width.type.desktop === "10"}
          onChange={handleChangeWidth}
        />
        <RadioButton
          label="Full Screen Width"
          id="11"
          checked={props.item.width.type.desktop === "11"}
          onChange={handleChangeWidth}
        />
        <RadioButton
          label="Adapt to image"
          id="12"
          checked={props.item.width.type.desktop === "12"}
          onChange={handleChangeWidth}
        />
      </Stack>
      {props.item.width.type.desktop === "9" && (
        <FormLayout.Group condensed>
          <TextField
            label="Minumum Width"
            value={props.item.width.minimumWidth.desktop}
            onChange={handleChangeMinimumWidth}
            type="number"
          />
          <TextField
            label="Maximum Width"
            value={props.item.width.maximumWidth.desktop}
            onChange={handleChangeMaximumWidth}
            type="number"
          />
        </FormLayout.Group>
      )}
      {props.item.width.type.desktop === "10" && (
        <TextField
          label="Custom Width"
          value={props.item.width.customWidth.desktop}
          onChange={handleChangeCustomWidth}
          type="number"
        />
      )}
      {/* <Checkbox
        label="Add Custom Mobile Width"
        checked={checkedMobileWidth}
        onChange={handleChangeCheckedMobileWidth}
      />
      {checkedMobileWidth && (
        <TextField
          label="Mobile Width"
          value={props.item.width.mobileWidth}
          onChange={handleChangeMobileWidth}
          type="number"
        />
      )} */}

      <Text variant="headingXs" as="h6">
        MOBILE
      </Text>
      <Stack horizontal>
        <RadioButton
          label="Minimum/Maximum Width"
          checked={props.item.width.type.mobile === "13"}
          id="13"
          onChange={handleChangeWidthMobile}
        />
        <RadioButton
          label="Custom Width"
          id="14"
          checked={props.item.width.type.mobile === "14"}
          onChange={handleChangeWidthMobile}
        />
        <RadioButton
          label="Full Screen Width"
          id="15"
          checked={props.item.width.type.mobile === "15"}
          onChange={handleChangeWidthMobile}
        />
        <RadioButton
          label="Adapt to image"
          id="16"
          checked={props.item.width.type.mobile === "16"}
          onChange={handleChangeWidthMobile}
        />
      </Stack>
      {props.item.width.type.mobile === "13" && (
        <FormLayout.Group condensed>
          <TextField
            label="Minumum Width"
            value={props.item.width.minimumWidth.mobile}
            onChange={handleChangeMinimumWidthMobile}
            type="number"
          />
          <TextField
            label="Maximum Width"
            value={props.item.width.maximumWidth.mobile}
            onChange={handleChangeMaximumWidthMobile}
            type="number"
          />
        </FormLayout.Group>
      )}
      {props.item.width.type.mobile === "14" && (
        <TextField
          label="Custom Width"
          value={props.item.width.customWidth.mobile}
          onChange={handleChangeCustomWidthMobile}
          type="number"
        />
      )}
    </FormLayout>
  );
};

export default WidthStyle;
